var map = {
	"./address_image.svg": 1984,
	"./animated_ashutosh.png": 205,
	"./animated_logo.svg": 6232,
	"./blogs_image.svg": 9449,
	"./cloud_infrastructure.svg": 7068,
	"./codeInLogo.png": 3248,
	"./contactMail.png": 4380,
	"./coursera_logo.png": 9756,
	"./data_science.svg": 9140,
	"./deeplearning_ai_logo.png": 6852,
	"./delhivery_logo.png": 1032,
	"./developerActivity.svg": 6052,
	"./dsc_logo.png": 9216,
	"./education.svg": 4972,
	"./experience.svg": 9148,
	"./feelingProud.svg": 8404,
	"./freecopy_logo.png": 9896,
	"./fullstack.svg": 3300,
	"./gcp_logo.png": 12,
	"./github_logo.png": 3956,
	"./googleAssistant.jpg": 8388,
	"./googleAssistant.svg": 7464,
	"./google_logo.png": 6976,
	"./ibm_logo.png": 4904,
	"./iiitk_logo.png": 7632,
	"./intel_logo.jpg": 5808,
	"./iu_logo.png": 7004,
	"./jsFramework.svg": 9716,
	"./legato_logo.png": 8280,
	"./manOnTable.svg": 1040,
	"./microsoft_logo.png": 9815,
	"./mozilla_logo.png": 29,
	"./muffito_logo.png": 9008,
	"./nextuLogo.jpg": 5052,
	"./nptel_logo.png": 340,
	"./portfolio.gif": 4136,
	"./programmer.svg": 2504,
	"./projects_image.svg": 6148,
	"./pwa.png": 6248,
	"./saayaHealthLogo.png": 7568,
	"./stanford_logo.png": 7380,
	"./talksCardBack.svg": 1084,
	"./talksCardBackAlt.svg": 480,
	"./tiktok_logo.png": 7788,
	"./ui_ux_design.svg": 4572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3832;